import * as constAction from 'root/actionConstants';

/**
 * Setea un campo o el reducer completo del componente con el default.
 * @param {string} value Nombre del campo a limpiar ("all" para todo el reducer).
 * @returns {Object}
 */
export const clear = value => ({
  type: constAction.PARADAS_CLEAR,
  payload: value,
});

/**
 * Setea un campo en el reducer .
 * @param {Object} values - Campos a setear.
 * @param {string} values.* - Nombre y valor del campo a setear.
 * @returns {Object}
 */
export const setState = values => ({
  type: constAction.PARADAS_SET_STATE,
  payload: values,
});

/**
 * Trae la lista de paradas .
 * @returns {Object}
 */
export const get = () => ({
  type: constAction.PARADAS_GET,
  payload: {
    filter: {
      where: {
        eliminada: false,
      },
    },
    order: 'nombre ASC',
  },
  epic: {
    url: 'paradas',
    method: 'GET',
  },
});

export const setSugerida = data => ({
  type: constAction.PARADAS_SUGERIDAS_SET,
  payload: data,
  epic: {
    url: 'paradasSugeridas/confirmar',
    method: 'POST',
  },
});

export const getSugeridas = () => ({
  type: constAction.PARADAS_SUGERIDAS_GET,
  payload: {
    filter: {
      include: {
        relation: '_usuario',
        scope: {
          fields: ['nombre', 'apellido', 'id'],
        },
      },
    },
    order: 'nombre ASC',
  },
  epic: {
    url: 'paradasSugeridas',
    method: 'GET',
  },
});

/**
 * Setea el marcador dentro de la parada .
 * @param {Object} ubicacion - Respuesta.
 * @param {float} ubicacion.lat - Latitud.
 * @param {float} ubicacion.lng - Longitud.
 * @returns {Object}
 */
export const addMarker = ubicacion => ({
  type: constAction.PARADAS_ADD_MARKER,
  payload: ubicacion,
});

/**
 * Trae una parada por id desde el backend .
 * @param {string} id - Id de la parada.
 * @returns {Object}
 */
export const getById = paradaId => ({
  type: constAction.PARADAS_GET_BY_ID,
  payload: { paradaId },
  epic: {
    url: 'paradas/getFull',
    method: 'GET',
  },
});

/**
 * Actualiza la lista de paradas del store .
 * @param {Object} result - Objeto que se ha modificado.
 * @returns {Object}
 */
export const actualizarState = payload => ({
  type: constAction.PARADAS_ACTUALIZAR_STATE,
  payload: payload,
});

/**
 * Crea una nueva parada .
 * @param {Object} data - Datos del formulario.
 * @param {string} [id] - Id de la parada ( para modificar).
 * @param {boolean} isPopup - Indica si el componente se usa como popup.
 * @returns {Object}
 */
export const set = (data, id, isPopup) => ({
  type: constAction.PARADAS_SET,
  isPopup,
  payload: {
    ...data,
  },
  epic: {
    url: id != 'new' ? 'paradas/' + id : 'paradas',
    method: id != 'new' ? 'PATCH' : 'POST',
  },
});

/**
 * Borra una parada .
 * @param {string} id - Id de la parada.
 * @returns {Object}
 */
export const delete_ = (id, isSugerida) => ({
  type: constAction.PARADAS_DELETE,
  isSugerida,
  payload: isSugerida ? null : id,
  epic: {
    url: (isSugerida ? 'paradasSugeridas/' : 'paradas/') + id,
    method: 'DELETE',
  },
});

//-- ACCIONES DE OTROS COMPONENTES --//
export const getRutinas = () => ({
  type: constAction.PARADAS_RUTINAS_GET,
  payload: {
    filter: { order: 'horario ASC' },
  },
  epic: {
    url: 'rutinas',
    method: 'GET',
  },
});



// WEBPACK FOOTER //
// src/modules/paradas/action.js